import { GameEngine } from 'react-game-engine';
export { GameEngine };
